import { Component, OnInit } from '@angular/core';
import { BaseAPIService } from '../Services/api.base.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { IHaccpReportDetail, IHaccpReportHistory, IReportConfiguration } from '../Models/IHaccpReportDetail';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IResourceList } from '../Models/IResourceList';
import { IDevicesNameValue } from '../Models/IControllerNames';
import { MessageService } from 'primeng/api';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { IUsersDetail } from '../Models/IUsersDetail';
import { INotifyName } from '../Models/INotifyTo';
import { EMPTY, Observable } from 'rxjs';
import { rolesdef } from '../constants/role-def'
import { IGridCols } from '../Models/IGridCols';
import { IDescValue } from '../Models/IDescValue';
import { IDropdownConfig } from '../Models/IDeviceMetadata';
@Component({
  selector: 'app-haccpReport',
  templateUrl: './haccp-reports.component.html',
  styleUrls: ['./haccp-reports.component.scss'],
  providers: [MessageService]
})
export class HaccpReportsComponent implements OnInit {
  historyColumns: Array<IGridCols>;
  cols: Array<IGridCols>;
  labels: any;
  messages: any;
  haccpReportDetail: IHaccpReportDetail[];
  modalReference: NgbModalRef;
  closeResult: string;
  contentHeader: string;
  resourceData: IResourceList[] = [];
  selectedResource: string[] = [];
  applyToNotifyToData: INotifyName[] = [];
  applyToNotifyName: any[] = [];
  applyToDeviceData: IDevicesNameValue[] = [];
  selectedDevice: any;
  reportFrequency: number;
  resourcesDrpdwnConfig: IDropdownConfig;
  countryDrpdwnConfig: IDropdownConfig;
  CanOnlySelectThemself: boolean = false;
  UserList: IUsersDetail[] = [];
  reportNameRequired: string;
  reportName: string;
  divStatus: boolean = false;
  isEdit: boolean = false;
  reportId: number = 0;
  action: string;
  btndiv: boolean = false;
  historyReportName: string = "";
  noData: boolean = false;
  isPagination: boolean = true;
  isHistoryPagination: boolean = true;
  isLoading: boolean = false;
  showmodal: boolean = false;
  showHistoryModal: boolean = false;
  showDeletemodal: boolean;
  reportConfiguration: IReportConfiguration;
  newReport: IHaccpReportDetail = {
    id: 0,
    reportName: '',
    frequency: 0,
    format: [],
    configuration: null,
    isActive: true,
    createdByFederatedId: this.auth.authenticatedUserId
  };
  currentReport: IHaccpReportDetail;
  dataFrequencyList: IDescValue[];
  formInvalid: boolean;
  selectedDataFreq: number;
  reportFormat: number[] = [];
  reportHistory: IHaccpReportHistory[];
  noHistoryData: boolean = false;

  displayInputBoxs: boolean = false;
  emialIds: string[] = [];
  notifiedTo: string;
  reportFormatPdf: number;
  reportFormatCsv: number;
  reportFormatExcel: number;
  defaultLoggedEmail:string;

  constructor(private readonly baseService: BaseAPIService, private readonly auth: AuthenticationService, private readonly messageService: MessageService,
    private readonly translate: TranslateService, private readonly _validateService: ValidateRulesService) { }

  ngOnInit() {
    this.labels = label;
    this.formInvalid = true;
    this.isLoading = true;
    this.messages = message;
    this.dataFrequencyList = [
      { desc: this.translate.instant(this.labels.selectDataFreq), value: 0 },
      { desc: this.translate.instant(this.labels.OneDataFreq), value: 1 },
      { desc: this.translate.instant(this.labels.TwoDataFreq), value: 2 },
      { desc: this.translate.instant(this.labels.ThreeDataFreq), value: 3 },
      { desc: this.translate.instant(this.labels.FourDataFreq), value: 4 }
    ]
    this.cols = [
      { field: 'reportName', header: this.labels.reportName, width: '40px' },
      { field: 'frequency', header: this.labels.ReportFrequency, width: '40px' },
      { field: 'notifyTo', header: this.labels.notify, width: '360px' }
    ];
    this.historyColumns = [
      { field: 'createdOn', header: this.labels.dgTblHeaderCreatedDate, dataType: 'date' },
      { field: 'downloadLink', header: this.labels.actions, dataType: 'string' },

    ]
    this.divStatus = false;
    this.isEdit = false;
    this.GetHaccpReportDetailList();
   
  }

  public async AddReport() {
    this.isLoading = true;
    if (this.applyToNotifyToData.length === 0) {
      await this.GetUserDetails();
    }
    if (this.applyToDeviceData.length === 0) {
      await this.GetDeviceDetails();
    }
    this.formInvalid = true;
    if (this.dataFrequencyList && this.dataFrequencyList.length > 0) {
      this.selectedDataFreq = this.dataFrequencyList[0].value;
    }
    this.showmodal = true;
    this.divStatus = false;
    this.isEdit = false;
    this.ResetReportObject();
    this.contentHeader = this.translate.instant(this.labels.AddReport);
    this.isLoading = false;
    this.defaultLoggedEmail = this.auth.authenticatedUserEmail;
    
  }

  public NotifyToSelectionChange($event: Event) {
    this.validate();
  }
  public DeviceSelectionChanged($event: Event) {
    this.selectedResource = [];
    this.validate();
    if (this.selectedDevice !== null) {
      this.isLoading = true;
      this.GetResources(this.selectedDevice);
    }
  }
  public ResourceSelectionChanged($event: Event) {

    if (this.selectedResource.length > 8) {
      this.messageService.add({
        severity: 'error', summary: this.translate.instant(this.messages.error),
        detail: this.translate.instant(this.messages.MaxResourceSelected), key: 'error'
      });
    }
    this.validate();
  }

  public ResetReportObject() {
    this.newReport = {
      id: 0,
      reportName: '',
      frequency: 0,
      format: [],
      configuration: null,
      isActive: true,
      createdByFederatedId: this.auth.authenticatedUserId
    }
    this.selectedResource = [];
    this.resourceData = null;
    this.applyToNotifyName = [];
    this.selectedDevice = null;
    this.reportName = '';
    this.reportId = 0;
    this.reportConfiguration = null;
    this.reportFrequency = 1;
    this.reportFormat = [];
    this.selectedDataFreq = 0;
    this.reportFormatPdf = null;
    this.reportFormatCsv = null;
    this.reportFormatExcel = null;
    this.emialIds = [];
  }

  public SaveReport() {
    if (this.reportName === '') {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidHaccpReport), detail: this.translate.instant(this.messages.invalidReportDetail), key: 'error' });
    }
    else if (this.reportFrequency === null) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidReportFreq), detail: this.translate.instant(this.messages.selectReportFreq), key: 'error' });
    }
    else if (this.reportFrequency > 1 && this.selectedDataFreq === 0) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidDataFreq), detail: this.translate.instant(this.messages.selectDataFreq), key: 'error' });
    }
    else if (this.selectedDevice === null) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidReportFormat), detail: this.translate.instant(this.messages.selectReportFormat), key: 'error' });
    }
    else if (this.selectedResource.length === 0) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidResource), detail: this.translate.instant(this.messages.selectResource), key: 'error' });
    }

    else if (this.reportFormat === null) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.invalidReportFormat), detail: this.translate.instant(this.messages.selectReportFormat), key: 'error' });
    } 
    else if (this.emialIds.some(e => !e || e.trim() === '')) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.notEmptyEmail), detail: this.translate.instant(this.labels.enterValidEmailAddress), key: 'error' });
    }
    else {
      let reportRecevierEmail;
      this.newReport.id = this.reportId;
      this.newReport.reportName = this.reportName;
      this.newReport.frequency = this.reportFrequency;
      this.newReport.format = this.reportFormat;
      if(this.emialIds.length > 0){
        reportRecevierEmail= this.emialIds.filter(e => !!e && e.trim() !== '').join(',');
      }
      this.newReport.configuration = {
        dataFrequency: this.selectedDataFreq,
        notifyToList: [],
        resourceIds: [],
        deviceDongleUId: this.selectedDevice,
        notifyToEmailList: reportRecevierEmail
      }

      for (const item in this.applyToNotifyName) {
        if (this.applyToNotifyName.hasOwnProperty(item)) {
          this.newReport.configuration.notifyToList.push(Number(this.applyToNotifyName[item]));
        }
      }
      for (const item in this.selectedResource) {
        if (this.selectedResource.hasOwnProperty(item)) {
          this.newReport.configuration.resourceIds.push(this.selectedResource[item]);
        }
      }
      this.SaveOrUpdateReport(this.newReport);
    }
  }

  public reportFrequencyChanged($event) {
    this.selectedDataFreq = 0;
  }

  public getSelectedFeq(){
    
  }

  public async EditReport(reportData: IHaccpReportDetail) {
    this.defaultLoggedEmail = this.auth.authenticatedUserEmail;
    if (this.applyToNotifyToData.length === 0) {
      await this.GetUserDetails();
    }
    if (this.applyToDeviceData.length === 0) {
      await this.GetDeviceDetails();
    }
    this.contentHeader = this.translate.instant(this.labels.UpdateReport);
    this.isLoading = true;
    this.divStatus = true;
    this.isEdit = true;
    this.reportId = reportData.id;
    this.reportName = reportData.reportName;
    this.reportFrequency = reportData.frequency;
    this.reportFormat = reportData.format;
    if(this.reportFormat.includes(1)){
        this.reportFormatPdf = 1
    }
    if(this.reportFormat.includes(2)){
      this.reportFormatCsv = 2
    }
    if(this.reportFormat.includes(3)){
      this.reportFormatExcel = 3
    }
    
    this.reportConfiguration = JSON.parse(JSON.stringify(reportData.configuration));
    this.selectedDataFreq = this.reportConfiguration.dataFrequency;
    
    
    if (this.reportConfiguration.notifyToEmailList) {
    // Split emails, trim, and filter out authenticatedUserEmail
      const allEmails = this.reportConfiguration.notifyToEmailList.split(',').map(e => e.trim()).filter(e => !!e);
      this.emialIds = allEmails.filter(email => email !== this.auth.authenticatedUserEmail);
      this.displayInputBoxs = this.emialIds.length > 0;
      this.notifiedTo = '';
    } else {
      this.emialIds = [];
    }
    if (this.reportConfiguration.notifyToList.length !== 0) {
      this.applyToNotifyName = this.reportConfiguration.notifyToList;

    }
    if (this.reportConfiguration.deviceDongleUId.length !== 0) {
      this.selectedDevice = this.reportConfiguration.deviceDongleUId;
    }
    if (this.reportConfiguration.resourceIds.length !== 0) {
      if (this.selectedDevice !== null) {
        this.GetResources(this.selectedDevice, reportData);
      }
    }
    else {
      this.selectedResource = [];
    }
    this.formInvalid = true;
  }
  public GetResources(deviceId: string, reportData?: IHaccpReportDetail) {

    this.baseService.GET(`/Telemetry/GetResourceList/${deviceId}`).subscribe((resourceData: Array<string>) => {
      this.resourceData = [];
      if (resourceData && resourceData.length > 0) {
        for (const resource of resourceData) {
          this.resourceData.push({
            key: resource,
            value: resource
          });
        }
        if (this.isEdit && reportData !== undefined) {
          this.selectedResource = this.reportConfiguration.resourceIds;

        }
        this.validate();
        this.showmodal = true;
        this.isLoading = false;
      }
    });
  }
  public EditReportStatus(rowdata: any, event: Event) {
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isLoading = true;
    this.messageService.clear();
    this.baseService.PUT(`/HaccpReport/UpdateHaccpReportState/${rowdata.id}`, {}).subscribe((result: boolean) => {
      this.isLoading = false;
      if (result === true) {

        rowdata.isActive = !rowdata.isActive;
        const msg = rowdata.isActive ? this.translate.instant(this.messages.activeReport) : this.translate.instant(this.messages.deactiveReport);
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Report ${rowdata.reportName} ${msg}`, key: 'success' });
      }
      else {
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: `Report ${rowdata.id} ${this.translate.instant(this.messages.errorAdd)}`, key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: `Report ${rowdata.id} ${this.translate.instant(this.messages.errorAdd)}`, key: 'error' });
    });
  }

  public DeleteReport(rowdata: any, event: Event) {
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.reportId = rowdata.id;
    this.reportName = rowdata.reportName;
    this.showDeletemodal = true;
    this.messageService.clear();

  }
  public OpenHistory(rowData: any, event: Event) {
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.reportHistory = [];
    this.historyReportName = rowData.reportName;
    this.showHistoryModal = true;
    this.messageService.clear();
    this.GetReportHistory(rowData.id);
  }
  GetReportHistory(reportId) {
    this.isLoading = true;
    this.baseService.GET(`/HaccpReport/HaccpReportsHistory/${reportId}`).subscribe((result: IHaccpReportHistory[]) => {
      if (result !== null && result.length > 0) {
        this.reportHistory = result.sort((a, b) => {
          return <any>new Date(b.createdOn) - <any>new Date(a.createdOn);
        });
        this.noHistoryData = false;
        if (this.reportHistory.length > 10) {
          this.isHistoryPagination = true;
        } else {
          this.isHistoryPagination = false;
        }
      } else {
        this.noHistoryData = true;
        this.isHistoryPagination = false;
      }
      this.isLoading = false;
    });
  }
  onConfirm() {
    this.messageService.clear('c');
    this.showDeletemodal = false;
    this.isLoading = true;
    this.baseService.PUT(`/HaccpReport/DeleteHaccpReport/${this.reportId}`, {}).subscribe((result: boolean) => {
      this.isLoading = false;
      if (result === true) {
        this.GetHaccpReportDetailList();
        const msg = this.translate.instant(this.messages.deleteReport);
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Report ${msg}`, key: 'success' });
      }
      else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: `Report ${this.translate.instant(this.messages.errorDeleteReport)}`, key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: `Report ${this.translate.instant(this.messages.errorDeleteReport)}`, key: 'error' });
    });
  }

  onReject() {
    this.messageService.clear('c');
    this.ResetReportObject();
  }


  public closeModal() {
    this.showmodal = false;
    this.showDeletemodal = false;
    this.isLoading = false;
    this.showHistoryModal = false;
    this.ResetReportObject();
  }

  public validate() {
    this.reportNameRequired = this._validateService.requiredElement(this.reportName, 'Report Name', 1, 500);
    this.formInvalid = this.reportNameRequired === ''  && (this.CanOnlySelectThemself || this.defaultLoggedEmail) &&
    this.selectedDevice !== null && this.selectedResource.length > 0 && this.selectedResource.length <= 8 ? false : true;
  }
  ////API Calls

  public GetHaccpReportDetailList() {
    this.baseService.GET('/HaccpReport/GetAllHaccpReports')
      .subscribe((result: IHaccpReportDetail[]) => {
        if (result !== null && result.length > 0) {
          this.haccpReportDetail = result;
          this.isLoading = false;
          if (this.haccpReportDetail.length < 10) {
            this.isPagination = false;
          }
        }
        else {
          this.haccpReportDetail = [];
          this.noData = true;
          this.isPagination = false;
          this.isLoading = false;
        }
      });
  }

  private GetDeviceApiCall(): Observable<any> {
    return this.baseService.GET('/DeviceDashboard/DeviceDetailForDashboard')

  }
  public async GetDeviceDetails() {
    const result = await this.GetDeviceApiCall().toPromise();
    if (result && (result && result.length > 0)) {
      const deviceList = result.filter(x => x.lastConnectedOn !== null);
      deviceList.forEach(item => {
        this.applyToDeviceData.push({
          name: item.name,
          dongleId: item.dongleUId
        });
      })
    }
  }
  SaveOrUpdateReport(reportData: IHaccpReportDetail) {
    let apiUrl = '';
    const customHeaders = {};
    let reportAddUpdateObs;

    if (this.isEdit) {
      apiUrl = "/HaccpReport/EditHaccpReport";
      reportAddUpdateObs = this.baseService.PatchWithHeaders(apiUrl, customHeaders, reportData);
    }
    else {
      apiUrl = "/HaccpReport/CreateHaccpReport";
      reportAddUpdateObs = this.baseService.PostWithHeaders(apiUrl, {}, reportData);
    }

    reportAddUpdateObs.subscribe((result) => {
      this.ResetReportObject();
      if (result === null || result > 0) {
        this.GetHaccpReportDetailList();
        this.showmodal = false;
        this.isLoading = false;
        if (this.isEdit === true) {
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Report ${reportData.reportName} ${this.translate.instant(this.messages.reportUpdated)}`, key: 'success' });
        }
        else {
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Report ${this.translate.instant(this.messages.reportAdd)}`, key: 'success' });
        }
      } else if (result.status === 400) {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.badRequest), detail: this.translate.instant(this.messages.invalidInput), key: 'error' });
      } else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAdd), key: 'error' });
      }
    }, (error) => {
      this.ResetReportObject();
      this.isLoading = false;
      this.showmodal = false;
      switch (error.error) {
        case this.messages.reportModelNotValid:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.reportModelNotValid), key: 'error' });
          break;
        case this.messages.noUserAccessToReport:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.noUserAccessToReport), key: 'error' });
          break;
        case this.messages.reportNameNotValid:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.reportNameNotValid), key: 'error' });
          break;

        case this.messages.duplicateReportName:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.duplicateReportName), key: 'error' });
          break;
        default:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.errorAdd), key: 'error' });
          break;
      }
    });
  }

  private GetUserApiCall(): Observable<any> {
    let apiUrl = '';
    this.CanOnlySelectThemself = false;
    switch (this.auth.authenticatedRoleCd) {
      case rolesdef.master:
        apiUrl = '/User/AllUsers';
        break;
      case rolesdef.enduser:
        apiUrl = '/User/AllChildUsersByEndUser';
        break;
      case rolesdef.cuserW:
        apiUrl = '/User/AllChildUsersByEndUser';
        break;
      default:
        this.CanOnlySelectThemself = true;
        break;
    }
    return !this.CanOnlySelectThemself ? this.baseService.GET(apiUrl) : EMPTY;
  }


  async GetUserDetails() {
    const result = await this.GetUserApiCall().toPromise();
    if (result) {
      if (result && result.length > 0) {
        result.forEach(item => {
          this.applyToNotifyToData.push({
            id: item.id,
            name: `${item.name} - [${item.email}]`
          });
        });
      } else {
        this.CanOnlySelectThemself = true;
      }
    }
  }

  showInputboxs(){
    
    this.displayInputBoxs = true;
    const email = this.notifiedTo?.trim();
    this.emialIds.push(email);
    this.notifiedTo = '';
    
  }

   trackByIndex(index: number, obj: any): any {
    return index;
  }

  removeEmail(idx: number) {
    this.emialIds.splice(idx, 1);
    this.validate();
  }

  onReportFormatChange() {
    this.reportFormat = [];
    if (this.reportFormatPdf) {
      this.reportFormat.push(1);
    }
    if (this.reportFormatCsv) {
      this.reportFormat.push(2);
    }
    if (this.reportFormatExcel) {
      this.reportFormat.push(3);
    }
    this.validate();
  }
}
